<template>
  <div class="main uvoto-dark-theme">
    <header class="header">
      <img src="../assets/uvoto.png" alt="Uvoto Logo" class="main-logo">
    </header>
    
    <section class="bienvenida animate-in">
      <h1 class="poppins-bold">
        Abre una nueva sesión e invita a los Usuarios a unirse
      </h1>
      <p class="subtitle">Recibe votaciones y comentarios todo en tiempo real</p>

      <div class="input-container">
        <input 
          v-model="tituloSesion" 
          type="text" 
          placeholder="Ponle un título a tu sesión"
          @keyup.enter="crearSesion"
        >
        <button @click="aperturarYCrear()" class="btn-crear" :disabled="loading">{{ loading ? '...' : 'Crear' }}</button>
      </div>
    </section>

    <footer class="footer">
      <p>Esperando nuevas creaciones derivaciones y mas</p>
      <p>Ademas las consecuencias son e volverme rico</p>
    </footer>
  </div>
</template>

<script>

import { doc, setDoc, getFirestore, addDoc, collection } from 'firebase/firestore'; //

export default {
  data() {
    return {
      tituloSesion: '',
      loading: false,
      canalId: 'general' // Puedes hacerlo dinámico si prefieres
    }
  },
  methods: {
  async aperturarYCrear() {
  if (!this.tituloSesion.trim()) return;

  this.loading = true;
  const db = getFirestore();
  // Generamos el PIN de acceso
  const pinAcceso = Math.floor(1000 + Math.random() * 9000).toString();

  try {
    const salaData = {
      pin: pinAcceso, // <--- Este es el código que el usuario escribirá
      nombreSesion: this.tituloSesion,
      preguntaActivaId: null, 
      color: '#6366f1',
      logo: '', 
      createdAt: new Date(),
      estado: 'abierto'
    };

    // 1. Crear documento con ID automático en la colección 'canales'
    const docRef = await addDoc(collection(db, "canales"), salaData);

    // 2. Guardamos el UID de Firestore (ej: "JkL92...") y el PIN (ej: "5582")
    localStorage.setItem('admin_canal_uid', docRef.id); 
    localStorage.setItem('admin_canal_pin', pinAcceso);
    localStorage.setItem('admin_canal_nombre', this.tituloSesion);

    // 3. Vamos al admin pasando el UID de Firestore
    this.$router.push({ 
      path: '/admin', 
      query: { id: docRef.id, pin: pinAcceso } 
    });

  } catch (error) {
    console.error(error);
  } finally {
    this.loading = false;
  }
}
  }
}
</script>

<style scoped>


.uvoto-dark-theme {
  background-color: #1a1a1a; /* Fondo oscuro sólido de tus capturas */
  color: white;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 60px 25px;
  box-sizing: border-box;
  overflow: hidden;
}

.main-logo {
  width: 130px; /* Tamaño ajustado según image_0744dc.png */
  height: auto;
}

.bienvenida {
  width: 100%;
  max-width: 450px;
  text-align: left;
}

.poppins-bold {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 34px; /* Tamaño de impacto según el diseño */
  line-height: 1.1;
  margin-bottom: 15px;
  letter-spacing: -0.5px;
}

.subtitle {
  font-size: 14px;
  color: #a0a0a0;
  margin-bottom: 40px;
}

/* Contenedor Input Píldora */
.input-container {
  background: white;
  border-radius: 50px;
  display: flex;
  align-items: center;
  padding: 6px 6px 6px 20px;
  width: 94%;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
}

.input-container input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-size: 15px;
  color: #333;
  font-family: sans-serif;
}

.btn-crear {
  background: black;
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.btn-crear:active {
  transform: scale(0.95);
}

/* Footer estilo texto pequeño */
.footer {
  text-align: center;
  color: #444;
  font-size: 10px;
  line-height: 1.4;
}

/* Animación de entrada suave */
.animate-in {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>